
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OfficialCommunicationPopup',
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    closePopup() {
      this.isVisible = false;
      this.$emit('close');
    },
  },
});
